export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
    sortable: false,
  },
];

export const columnsLabels = {};

export const schema = {};
